<template>
            <div id="learingTikuCollect">
              <backHeader back-addr="/indexKaoyan"></backHeader>
                <br />

                <div v-show="tikuListShow">
                  <div @click="closeTikuList()" style="width:100%;text-align:center;">X</div>
                  <div class="flex-container" >
                  <div v-for="(item,index) in list">
                    <a @click="goChooseTiku(item,index)" v-if="item.answerSituation==2" class="right">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else-if="item.answerSituation==1" class="wrong">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else class="notAnswer">{{index+1}}</a>
                  </div>
                </div>
                </div>
                
                <div class="" v-if="hasCollect" style="padding-left:10px;padding-right:10px;border-bottom:1px solid #BBBBBB;" v-show="!tikuListShow">
                            <div style="display:flex;text-align:center;">
                                <div style="flex:1;text-align:left;">
                                    <mt-badge size="small" color="#888">{{showType(tiku.type)}}</mt-badge>
                                </div>
                                <div style="flex:1;">
                                    <span style="font-size:0.8rem;" @click="goTikuList">{{answerCount+1}}/{{totalCount}}</span>
                                </div>
                                <div style="flex:1;text-align:right;">
                                    <!-- <img class="mui-media-object mui-pull-left" :src="collection" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                                    <span style="font-size:0.8rem;">收藏</span> -->
                                    <collect-element v-bind:collect-data="tiku" v-bind:collect-state="tiku.collectionType" v-bind:collect-id="tiku.id" v-bind:collect-type="'tikuCollect'"></collect-element>
                                </div>
                            </div>
                            <br />
                            <div class="">
                                <div class="">
                                    <span style="font-size:16px;">{{tiku.content}}：</span>
                                </div>
                            </div>
                            <br />
                            
                            <mt-checklist v-model="answerCheckBoxArr" :options="options">
                            </mt-checklist>

                            <div class="" style="display:flex">
                                    <!-- <button style="flex:1" type="button" class="" @click="submitTiku()" v-show="tiku.answerAble == true">确定</button> -->
                                    <mt-button style="flex:1" plain type="danger" @click="submitTiku()" v-show="tiku.answerAble == true">确定</mt-button>
                            </div>

                            
                            <br />
                            <div class="" v-show="tiku.showAnswerStatus">
                                <div class="">
                                    <span v-if="tiku.answerSituation==1" style="color:red;">错误</span>
                                    <span v-if="tiku.answerSituation==2" style="color:green;">正确</span>
                                    <span style="font-size:0.8rem;">正确答案为:{{tiku.answer}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="" v-show="tiku.showAnswerStatus">
                                <div class="">
                                    <span style="font-size:0.8rem;">解析:{{tiku.tip}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="" style="display:flex">
                               <mt-button style="flex:1" plain type="danger" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</mt-button>
                              <mt-button style="flex:1" plain type="danger" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</mt-button>
                                    <!-- <button style="flex:1" type="button" class="" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</button>
                                    <button style="flex:1" type="button" class="" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</button> -->
                            </div>

                            
                        </div>
                <div style="height:60px;"></div>
            </div>
</template>

<script>
import axios from "axios";
import Qs from 'qs'
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import CollectElement from "@/components/collect";
import { Toast, MessageBox } from "mint-ui";
import backHeader from "./../components/back-header.vue";

export default {
  components: {
    CollectElement,
    backHeader
  },
  data() {
    return {
      answerCheckBoxArr: [],
      //checklist设置
      options: [],
      tikuInfo:{
        rightNum:0,//答对题目数
        wrongNum:0,//答错题目数
        notAnswerNum:0,//未答题目数
        randomId:0,//随机答题答道哪个id的题目了
      },
      //是否显示题目列表
      tikuListShow: false,
      //收藏是否为空
      hasCollect:true,
      showAnswerStatus: false,
      //答案字符串
      answerString: "",
      
      list: [
         {
          answerAble:true,
          answer: "A",
          four: "加载中",
          one: "加载中",
          tip: "无",
          id: 6,
          type: 1,
          two: "加载中",
          three: "加载中",
          content:
            "加载中"
        }
      ],
      totalCount: 3,
      answerCount: 0,
      tempTiku: "",
      //当前题目
      tiku: {
          answerAble:true,
          answer: "A",
          four: "加载中",
          one: "加载中",
          tip: "无",
          id: 6,
          type: 1,
          two: "加载中",
          three: "加载中",
          content:
            "加载中"
        },
      //上一道题目
      prevTiku: ""
    };
  },
  props: {},
  watch: {},
  methods: {
    goChooseTiku(item,index){
      //关闭题目列表
      this.tikuListShow=false;
      //题目等于item
      this.tiku=item;
      this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
      //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
      //获取该题目的序号
      this.answerCount=index;
      //关闭答案
      //this.showAnswerStatus = false;
      //清除选择按钮
      //this.clearCheckBox();
    },
    closeTikuList() {
      this.tikuListShow = false;
    },
    goTikuList() {
      console.log("go tiku list");
      this.tikuListShow = true;
    },

    submitTiku() {
      var count = this.answerCheckBoxArr.length;
      
      this.answerString = this.answerCheckBoxArr.join(",");
      
      if (this.tiku.type == 1 && count > 1) {
        MessageBox.alert("单选题只能选择一个答案！", "提示");
        return;
      }
      if (count == 0) {
        MessageBox.alert("至少选择一个答案！", "提示");
        return;
      }
      if (this.tiku.type == 2 && count < 2) {
        MessageBox.alert("多选题最少选择二个答案！", "提示");
        return;
      }


      this.$nextTick(()=>{
        
        //设置已经答题问题的信息
        this.list[this.answerCount].answerCheckBoxArr=this.answerCheckBoxArr;
        this.list[this.answerCount].answerAble=false;
        this.tiku.answerAble=false;
        this.tiku.showAnswerStatus=true;
        this.list[this.answerCount].showAnswerStatus=true;

        console.log("tick list is:");
        console.log(this.list[this.answerCount]);
        console.log("tiku tiku is:");
        console.log(this.tiku);
      });

      console.log("answerString is:");
      console.log(this.answerString);
      if (this.answerString == this.tiku.answer) {
        this.showAnswerStatus = true;
        MessageBox.alert("回答正确！", "提示");
        //this.list[this.answerCount].answerRight=true;
        //将答对的信息设置一下*********
        this.list[this.answerCount].answerSituation=2;

        return;
      } else {
        this.showAnswerStatus = true;
         MessageBox.alert("回答错误！", "提示");
        //this.list[this.answerCount].answerRight=false;
        //将答错的信息设置一下*********
        this.list[this.answerCount].answerSituation=1;


        // //将错误题目写入redis数据库
        // var redisKey=this.$store.state.appData.userId+"-"+"tikuWrong";
        // var redisValue=this.tiku.id;
        // axios
        // .post(
        //   getGoAPIPrefix() + "user/collect",
        //   Qs.stringify({
        //     key: redisKey,
        //     value: redisValue,
        //     operation:1
        //   })
        // )
        // .then(res => {
        //   if (res.data.returnCode == 100) {
        //     console.log("collect success");
        //     console.log("userId is:");
        //     console.log(res.data.returnData);

        //   } 
        // })
        // .catch(err => {
        //   mui.toast("收藏功能异常！");
        //   console.log("collect failed");
        //   console.log(err);
        // });
        // return;
      }
      //   console.log("answer is:");
      //   console.log(this.answerCheckBox);
    },
    showPrevTiku() {
      //this.showAnswerStatus = false;
      //this.clearCheckBox();
      if (this.answerCount > 1) {
        this.answerCount--;
        this.prevTiku = this.list[this.answerCount];
        this.tiku = this.list[this.answerCount];
        this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
      } else if (this.answerCount == 1) {
        this.answerCount--;
        this.tiku = this.list[0];
        this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
        this.prevTiku = "";
      } else {
        console.log("已经是最开始了");
      }
    },
    showNextTiku() {
      //this.showAnswerStatus = false;
      //this.clearCheckBox();
      this.randomGetTiku();
    },
    //初始化随机取出一个题目
    initRandomTiku() {
      // //将题目从list随机生成为randomTikus
      // while (this.list.length != 0) {
      //   var index = Math.floor(Math.random() * this.list.length);
      //   this.tempTiku = this.list[index];

      //   this.randomTikus.push(this.tempTiku);
      //   this.list.splice(index, 1);
      // }
      // //
      // this.tiku = this.randomTikus[0];
      // console.log("this tiku is:",this.tiku);
      // this.prevTiku = "";

      this.tiku = this.list[0];
      this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
      //根据上次打开的位置跳转
      //this.tiku=this.list[this.tikuInfo.randomId];
      //this.answerCount=this.tikuInfo.randomId;
      this.prevTiku = "";
    },
    //取出一个题目
    randomGetTiku() {
      if (this.answerCount < this.list.length - 1) {
        this.prevTiku = this.tiku;
        this.answerCount++;
        //this.tiku = this.randomTikus[this.answerCount];
        this.tiku = this.list[this.answerCount];
        this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(()=>{
          this.answerCheckBoxArr=this.tiku.answerCheckBoxArr;
        });
      } else {
        console.log("已经答完题目");
      }
    },
    showType: function(cellValue) {
      if (cellValue == "1") {
        return "单选";
      } else if (cellValue == "2") {
        return "多选";
      }
    },
    initTikuData() {
      axios
        .get(Addr.getGoAPIPrefix() + "tiku/listTikuCollect?pageNum=1&pageRow=1000&id="+this.$store.state.mineStore.userId)
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //如果没有收藏，则不显示题目
            if(res.data.returnData.list ==null){
              this.hasCollect=false;
              MessageBox.alert("没有收藏的题目！", "提示");
            }

            //设置相关默认值
            for(var j=0;j<res.data.returnData.list.length;j++){
              //默认为未答状态
              res.data.returnData.list[j].answerSituation=-1;
              //默认为全部未勾选的状态
              res.data.returnData.list[j].answerAble=true;
              res.data.returnData.list[j].answerCheckBoxArr=[];
              res.data.returnData.list[j].showAnswerStatus=false;
              //res.data.returnData.list[j].answerRight=null;
            }

            //初始化赋值题目列表，以及题目总数，还有随机抽取出第一道题目
            this.list = res.data.returnData.list;
            console.log("this list is:",this.list);
            // //默认设置收藏状态
            // this.list.forEach(function(value, index, array) {
            //   array[index].collectionType = false;
            // });

            // //如果没有收藏，则不显示题目
            // if(this.list ==null){
            //   this.hasCollect=false;
            //   mui.toast("没有收藏的题目！");
            // }
            this.totalCount = this.list.length;
            this.initLocalCacheData();
            //0621
            this.initRandomTiku();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    initLocalCacheData(){
      if(localStorage.getItem("tikuInfo")===null||localStorage.getItem("tikuInfo")===undefined){
        
      }else{
        this.tikuInfo=JSON.parse(localStorage.getItem("tikuInfo"));
      }
      if(localStorage.getItem("tikuAnswerSituation")===null||localStorage.getItem("tikuAnswerSituation")===undefined){
        return;
      }
      //记录答题情况 答对为2 答错为1 未答为-1
      this.localTikuAnswerSituation=JSON.parse(localStorage.getItem("tikuAnswerSituation"));
      // console.log("localTikuAnswerSituation is:");
      // console.log(this.localTikuAnswerSituation[1]);
      var localLen=this.localTikuAnswerSituation.length;
      var Len=this.list.length;
      //循环获取最新list中题目的情况
      for(var j=0;j<Len;j++){
        //查找是否有本地答题状态的记录
        for(var i=0;i<localLen;i++){
          // console.log("id1 is:");
          // console.log(this.localTikuAnswerSituation[i].id);
          // console.log("id2 is:");
          // console.log(this.list[j].id);
          //如果id相等，且answerSituation不为空的情况下
          if(this.localTikuAnswerSituation[i].id==this.list[j].id&&this.localTikuAnswerSituation[i].answerSituation){
            this.list[j].answerSituation=this.localTikuAnswerSituation[i].answerSituation;
            continue;
          }
        }
      }
      
    }
  },
  filters: {},
  computed: {},
  created() {
    this.initTikuData();
    // this.initRandomTiku();
  },
  mounted() {
    
  },
  beforeDestroy(){
    console.log("beforeDestroy");
    
    this.localTikuAnswerSituation = JSON.parse(
      localStorage.getItem("tikuAnswerSituation")
    );
    
    var localLen = this.localTikuAnswerSituation.length;
    var Len = this.list.length;
    //改变题目的答题状态
    for (var j = 0; j < localLen; j++) {
      
      for (var i = 0; i < Len; i++) {
        //如果id相等，且answerSituation不为空的情况下
        if (this.localTikuAnswerSituation[j].id == this.list[i].id &&this.list[i].answerSituation) {
          this.localTikuAnswerSituation[j].answerSituation=this.list[i].answerSituation;
          continue;
        }
      }
    }

    //初始化答题情况信息
    if(localStorage.getItem("tikuInfo")===null||localStorage.getItem("tikuInfo")===undefined){
        this.tikuInfo={
          rightNum:0,//答对题目数
          wrongNum:0,//答错题目数
          notAnswerNum:0,//未答题目数
          randomId:0//随机答题答道哪个id的题目了
        };
    }else{
        this.tikuInfo=JSON.parse(localStorage.getItem("tikuInfo"));
        this.tikuInfo.rightNum=0;
        this.tikuInfo.wrongNum=0;
        this.tikuInfo.notAnswerNum=0;
    }
    //统计答题情况
    for(var i=0;i<this.localTikuAnswerSituation.length;i++){
      if(this.localTikuAnswerSituation[i].answerSituation==2){
        this.tikuInfo.rightNum++;
      }
      if(this.localTikuAnswerSituation[i].answerSituation==1){
        this.tikuInfo.wrongNum++;
      }
      if(this.localTikuAnswerSituation[i].answerSituation==-1){
        this.tikuInfo.notAnswerNum++;
      }
    }//for
    localStorage.setItem("tikuInfo",JSON.stringify(this.tikuInfo));

    localStorage.setItem("tikuAnswerSituation", JSON.stringify(this.localTikuAnswerSituation));
  },
  destroyed() {}
};
</script>

<style scoped>
#about {
  width: 100%;
  height: 100%;
}

#about-img {
  width: 100%;
}

p {
  margin-left: 15px;
  margin-right: 15px;
}


.flex-container div {
  flex: 1;
  margin: 3px;
  width: 40px;
  height: 40px;
  display: inline-block;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 25px;
  background-clip: padding-box;
  min-width: 12%;
  max-width: 12%;
  vertical-align: center;
  line-height: 40px;
}

.wrong{
  color: red;
}

.right{
  color:green;
}

.notAnswer{
  color: gray;
}
</style>


// WEBPACK FOOTER //
// src/module-tiku/tikuCollect.vue